import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminNewsletter = lazy(() => import("@/pages/admin/AdminNewsletter"));

export const Route = createFileRoute("/admin/nyhetsbrev")({
  component: () => <AdminNewsletter />,
});
